import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../global/api';
import { CostCalculationApiResponse } from '../buy-process-form/buy-process-form-types';

export const fetchConfigFees = createAsyncThunk(
  'configuration/fees',
  async () => {
    const response = await api.get<CostCalculationApiResponse>('/cost', {
      params: {
        beneficial: true,
        nameReview: true,
        taxHelp: true,
      },
    });
    return response.data.fees;
  },
);
